import type { ModelVersionChecks } from "../../../api/content/ontologyApi";
import type { CheckStatus } from "../../../api/content/reviewDecoders";
import { CHECK_STATUS_TONE } from "../../reviews/checks/checkStatusTone";
import type { ChipTone } from "../../../ui/styles/chipStyles";

/** What the version's check chip says: how many checks fail, else whether any could not run,
 * else how many questions are not checked, else that all pass. The model's and the process
 * graph's checks count alike. */
export interface VersionCheckSummary {
  readonly tone: ChipTone;
  readonly key: (typeof CHIP_KEY)[CheckStatus];
  /** How many results have the status the chip names. */
  readonly count: number;
}

/** The chip's wording of each status, the most urgent first. */
const CHIP_KEY = {
  fail: "fail",
  cannot_run: "notRun",
  not_checked: "notChecked",
  pass: "pass",
} as const satisfies Record<CheckStatus, string>;

export function versionCheckSummary(checks: ModelVersionChecks): VersionCheckSummary {
  const results = [...checks.results, ...checks.processResults];
  for (const status of Object.keys(CHIP_KEY) as CheckStatus[]) {
    const count = results.filter((result) => result.status === status).length;
    if (count > 0) return { tone: CHECK_STATUS_TONE[status], key: CHIP_KEY[status], count };
  }
  return { tone: CHECK_STATUS_TONE.pass, key: CHIP_KEY.pass, count: 0 };
}
